import type { BlendMode } from './types';

/**
 * Integer ids handed to `composite.frag`. Keep in sync with the `BLEND_*`
 * constants at the top of `src/gl/shaders/blending.glsl`.
 */
export const BLEND_MODE_IDS: Record<BlendMode, number> = {
  normal: 0,
  multiply: 1,
  screen: 2,
  overlay: 3,
  darken: 4,
  lighten: 5,
  colorDodge: 6,
  colorBurn: 7,
  hardLight: 8,
  softLight: 9,
  difference: 10,
  exclusion: 11,
  hue: 12,
  saturation: 13,
  color: 14,
  luminosity: 15,
};

export const BLEND_MODE_LABELS: Record<BlendMode, string> = {
  normal: 'Normal',
  multiply: 'Multiply',
  screen: 'Screen',
  overlay: 'Overlay',
  darken: 'Darken',
  lighten: 'Lighten',
  colorDodge: 'Color Dodge',
  colorBurn: 'Color Burn',
  hardLight: 'Hard Light',
  softLight: 'Soft Light',
  difference: 'Difference',
  exclusion: 'Exclusion',
  hue: 'Hue',
  saturation: 'Saturation',
  color: 'Color',
  luminosity: 'Luminosity',
};

/** Groups shown as separated sections in the layer panel dropdown. */
export const BLEND_MODE_GROUPS: BlendMode[][] = [
  ['normal'],
  ['darken', 'multiply', 'colorBurn'],
  ['lighten', 'screen', 'colorDodge'],
  ['overlay', 'softLight', 'hardLight'],
  ['difference', 'exclusion'],
  ['hue', 'saturation', 'color', 'luminosity'],
];
